import { types } from "../actions";

const initialState = {
  userRole: "",
};

const userRoleReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_ROLE:
      return {
        userRole: action.payload,
      };
    case types.ROLE_LIST:
      return {
        roleList: action.roleList,
      }
      case types.USER_ROLE_LIST:
      return {
        userRoleList: action.userRoleList,
      }
    default:
      return state;
  }
};

export default userRoleReducer;
